// extracted by css-extract-rspack-plugin
export default {"CreateIssueDialogContainer":"CreateIssueDialog-module__CreateIssueDialogContainer__EDBUx"};